import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RequireAuth } from "@components/auth/RequireAuth";
import { CustomerLayout } from "@components/layout/CustomerLayout";

const Home = React.lazy(() => import("@pages/Home").then((m) => ({ default: m.Home })));
const Login = React.lazy(() => import("@pages/Login").then((m) => ({ default: m.Login })));
const ForgotPassword = React.lazy(() =>
    import("@pages/ForgotPassword").then((m) => ({ default: m.ForgotPassword }))
);
const Otp = React.lazy(() => import("@pages/Otp").then((m) => ({ default: m.Otp })));
const ResetPassword = React.lazy(() =>
    import("@pages/ResetPassword").then((m) => ({ default: m.ResetPassword }))
);
const History = React.lazy(() => import("@pages/History").then((m) => ({ default: m.History })));
const Payment = React.lazy(() => import("@pages/Payment").then((m) => ({ default: m.Payment })));
const PaymentReturn = React.lazy(() =>
    import("@pages/PaymentReturn").then((m) => ({ default: m.PaymentReturn }))
);
const Settings = React.lazy(() => import("@pages/Settings").then((m) => ({ default: m.Settings })));
const Notifications = React.lazy(() =>
    import("@pages/Notifications").then((m) => ({ default: m.Notifications }))
);

const RouteFallback: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="flex min-h-screen items-center justify-center text-neutral-secondary">
            {t("common.loading")}
        </div>
    );
};

export const Router: React.FC = () => (
    <Suspense fallback={<RouteFallback />}>
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/otp" element={<Otp />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route
                element={
                    <RequireAuth>
                        <CustomerLayout />
                    </RequireAuth>
                }
            >
                <Route path="/" element={<Home />} />
                <Route path="/history" element={<History />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/notifications" element={<Notifications />} />
            </Route>
            <Route
                path="/payment"
                element={
                    <RequireAuth>
                        <Payment />
                    </RequireAuth>
                }
            />
            <Route
                path="/payment/return"
                element={
                    <RequireAuth>
                        <PaymentReturn />
                    </RequireAuth>
                }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    </Suspense>
);
